import React from "react";
import { Row, Col, Form, Input, Select, Button, Popover } from "antd";
import { FaKeyboard } from "react-icons/fa";

import ProfileFormGroup from "./ProfileFormGroup";

import HiraganaKeyboard from "./HiraganaKeyboard";

import {
    replaceCodeWithHiragana,
    getCodeFromHiraganaString,
} from "./HiraganaKeyboard/hiragana";

const SettingsNamePlate = ({ currentPlayer, userData, setProfile }) => {
    let profileDataKey;

    if (currentPlayer === 1) {
        profileDataKey = "profile_p1";
    } else {
        profileDataKey = "profile_p2";
    }

    const handleOnChange = (changedFields) => {
        let profileObject = {
            ...userData[profileDataKey],
        };

        changedFields.forEach((field) => {
            let name = field.name[0];
            let value = field.value;

            if (name === "userName") {
                profileObject.userName = getCodeFromHiraganaString(value);
            } else {
                profileObject[name] = value;
            }
        });

        setProfile(profileObject, currentPlayer);
    };

    return (
        <Row gutter={16} style={{ marginBottom: `16px` }}>
            <Col span={24}>
                <ProfileFormGroup
                    cardProps={{
                        title: "Name Plate",
                    }}
                    formProps={{
                        onFieldsChange: handleOnChange,
                        fields: [
                            {
                                name: ["userName"],
                                value: replaceCodeWithHiragana(
                                    userData[profileDataKey].userName
                                ),
                            },
                            {
                                name: ["userTitle"],
                                value: userData[profileDataKey].userTitle,
                            },
                            {
                                name: ["userTitleShougouBase"],
                                value: userData[profileDataKey]
                                    .userTitleShougouBase,
                            },
                        ],
                    }}
                >
                    <Form.Item
                        name="userName"
                        label="Name"
                        tooltip="Hiragana (ひらがな) characters only."
                    >
                        <Input
                            type="text"
                            size="large"
                            suffix={
                                <Popover
                                    content={
                                        <HiraganaKeyboard
                                            player={currentPlayer}
                                        />
                                    }
                                    placement="bottomRight"
                                    title="Hiragana Keyboard"
                                    trigger="click"
                                >
                                    <Button
                                        type="text"
                                        size="large"
                                        style={{
                                            fontSize: "18px",
                                            padding: ` 2px 5px`,
                                            borderRadius: `2px`,
                                            height: `30px`,
                                        }}
                                    >
                                        <FaKeyboard />
                                    </Button>
                                </Popover>
                            }
                        />
                    </Form.Item>

                    <Form.Item name="userTitle" label="Title">
                        <Input type="text" />
                    </Form.Item>

                    <Form.Item name="userTitleShougouBase" label="Shougou Base">
                        <Select
                            placeholder="Select a shougou base"
                            style={{ width: "100%" }}
                        >
                            <Select.Option value={0}>Wood</Select.Option>
                            <Select.Option value={1}>Rainbow</Select.Option>
                            <Select.Option value={2}>Gold</Select.Option>
                            <Select.Option value={3}>Purple</Select.Option>
                            <Select.Option value={4}>AI 1</Select.Option>
                            <Select.Option value={5}>AI 2</Select.Option>
                            <Select.Option value={6}>AI 3</Select.Option>
                            <Select.Option value={7}>AI 4</Select.Option>
                        </Select>
                    </Form.Item>
                </ProfileFormGroup>
            </Col>
        </Row>
    );
};

export default SettingsNamePlate;
